export const CMS_DATA_CONSTANTS = {
  useMockLabels: process.env.REACT_APP_USE_CMS_DATA_MOCKS === 'true',
};
